import React from 'react';
import { Link } from 'react-router-dom';
import logoUxag from '../../assets/logo-uxag.png';
import FigmaIcon from '../Icons/FigmaIcon';
import GitHubIcon from '../Icons/GitHubIcon';
import LiveIcon from '../Icons/LiveIcon';
import BackIcon from '../Icons/BackIcon';
import NewTabIcon from '../Icons/NewTabIcon';
import './Header.css';

interface HeaderProps {
  showStats?: boolean;
  sectionCount?: number;
  templateCount?: number;
  figmaUrl?: string;
  githubUrl?: string;
  liveUrl?: string;
  subtitle?: string;
  viewingPage?: string;
  onBackClick?: () => void;
  onNewTabClick?: () => void;
}

const Header: React.FC<HeaderProps> = ({ 
  showStats = false, 
  sectionCount = 0, 
  templateCount = 0,
  figmaUrl,
  githubUrl,
  liveUrl,
  subtitle,
  viewingPage,
  onBackClick,
  onNewTabClick
}) => {


  return (
    <header className="app-header">
      <div className="header-background"></div>
      <div className="header-overlay"></div>
      <div className="header-content">
        <div className="header-left">
          <Link to="/" className="brand-section">
            <div className="brand-logo-container">
              <img 
                src={logoUxag} 
                alt="UX Agency Logo" 
                className="brand-logo"
              />
              <span className="platform-name">Preview</span>
              <span className="brand-trademark">®</span>
            </div>
            <div className="brand-slogan">
              Page Display Platform
            </div>
          </Link>
        </div>
        
        <div className="header-center">
          <h1 className="project-title">Data Stone</h1>
          {subtitle && <p className="project-subtitle">{subtitle}</p>}
          {viewingPage && (
            <div className="brand-section">
              <span className="viewing-page" data-tooltip={viewingPage}>{viewingPage}</span>
            </div>
          )}
        </div>

        <div className="header-right">
          <div className="brand-section">
            {/* Show stats and action tabs only when not in viewing mode */}
            {!viewingPage && showStats && (
              <>
                <div className="stat-item project-stat">
                  <span className="project-name">Data Stone</span>
                </div>
                <div className="stat-divider"></div>
                <div className="stat-item">
                  <span className="stat-number">{sectionCount}</span>
                  <span className="stat-label">Sections</span>
                </div>
                <div className="stat-divider"></div>
                <div className="stat-item">
                  <span className="stat-number">{templateCount}</span>
                  <span className="stat-label">Screens</span>
                </div>
                <div className="stat-divider"></div>
                <div className="stat-item">
                  <span className="stat-number">v1</span>
                  <span className="stat-label">Version</span>
                </div>
                <div className="tab-divider"></div>
              </>
            )}
            {!viewingPage && <>
              {/* Figma icon */}
              <a
                href={figmaUrl || '#'}
                target="_blank"
                rel="noopener noreferrer"
                className="action-tab-item figma-tab"
                title="Figma"
                style={!figmaUrl ? { pointerEvents: 'none', opacity: 0.5 } : {}}
                aria-disabled={!figmaUrl}
              >
                <FigmaIcon />
              </a>
              <div className="tab-divider"></div>
              {/* GitHub icon */}
              <a
                href={githubUrl || '#'}
                target="_blank"
                rel="noopener noreferrer"
                className="action-tab-item github-tab"
                title="GitHub"
                style={!githubUrl ? { pointerEvents: 'none', opacity: 0.5 } : {}}
                aria-disabled={!githubUrl}
              >
                <GitHubIcon />
              </a>
              <div className="tab-divider"></div>
              {/* Live Preview icon */}
              <a
                href={liveUrl || '#'}
                target="_blank"
                rel="noopener noreferrer"
                className="action-tab-item live-tab"
                title="Live Preview"
                style={!liveUrl ? { pointerEvents: 'none', opacity: 0.5 } : {}}
                aria-disabled={!liveUrl}
              >
                <LiveIcon />
              </a>
              <div className="tab-divider"></div>
            </>}
            {/* Navigation tabs for theme viewer - only show when viewing */}
            {viewingPage && (
              <>
                {onBackClick && (
                  <button onClick={onBackClick} className="action-tab-item" title="Back to Overview">
                    <BackIcon />
                    <span className="tab-text">Back</span>
                  </button>
                )}
                {onBackClick && onNewTabClick && <div className="tab-divider"></div>}
                {onNewTabClick && (
                  <button onClick={onNewTabClick} className="action-tab-item" title="Open in New Tab">
                    <NewTabIcon />
                    <span className="tab-text">New Tab</span>
                  </button>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header; 